import { useEffect, useRef } from 'react';
import * as pdfjs from 'pdfjs-dist';
// @ts-ignore
// Temporary solution (until we review the final design)
// TypeScript does not understand the `?url` import syntax used by bundlers (Vite/CRA) for static assets.
// This import returns the public URL of the PDF.js worker script as a string at build time.
// We ignore the type error here because the bundler will handle it correctly.
// import workerSrc from '/pdf.worker.min.js';

pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

type Props = { url: string };

export default function InvoiceCanvasViewer({ url }: Props) {
    const containerRef = useRef<HTMLDivElement>(null);
    const isInitialRenderRef = useRef(true);
    useEffect(() => {
        if (!url || !containerRef.current) return;

        let destroyed = false;
        const container = containerRef.current;

        const render = async () => {
            container.innerHTML = '';

            const loadingTask = pdfjs.getDocument(url);
            const pdf = await loadingTask.promise;
            if (destroyed) return;

            for (let n = 1; n <= pdf.numPages; n++) {
                const page = await pdf.getPage(n);
                if (destroyed) break;

                const viewport = page.getViewport({ scale: 1 });
                const targetWidth = container.clientWidth;
                const scale = targetWidth / viewport.width;
                const scaledViewport = page.getViewport({ scale });

                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d')!;
                canvas.width = Math.ceil(scaledViewport.width);
                canvas.height = Math.ceil(scaledViewport.height);
                canvas.style.display = 'block';
                canvas.style.background = '#fff';
                canvas.style.boxShadow = 'none';
                canvas.style.border = 'none';
                canvas.style.outline = 'none';

                container.appendChild(canvas);

                await page.render({
                    canvasContext: ctx,
                    viewport: scaledViewport,
                    background: 'white',
                }).promise;
            }
        };

        render();

        const ro = new ResizeObserver(() => {
            if (isInitialRenderRef.current) {
                isInitialRenderRef.current = false;
                return;
            }
            render();
        });
        ro.observe(container);

        return () => {
            destroyed = true;
            ro.disconnect();
            container.innerHTML = '';
            isInitialRenderRef.current = true;
        };
    }, [url]);

    return (
        <div
            ref={containerRef}
            style={{
                width: '100%',
                height: '100%',
                overflow: 'auto',
                background: '#f8fafc',
                padding: 0,
            }}
        />
    );
}
